







import { Component, Prop, Vue } from "vue-property-decorator";
import ECPSigner from "@/components/ui/ECPSigner.vue";
import * as xml2js from "xml2js";
import { SignService } from "@/services/sign.service";
import { BaseModule } from "@/store/base.module";
import { RequestsModule } from "@/store/requests.module";
import { ParamData, Requests, RequestsDTO } from "../../../lib/requests.type";
import { AuthModule } from "@/store/auth.module";
import { translate } from "@/utils";
import { ReportsModule } from "@/store/reports.module";
import { ReportAction, ReportMode } from "~/services/report";

@Component({
  components: { ECPSigner },
})
export default class SignRequest extends Vue {
  formData: ParamData = new ParamData();
  @Prop()
  private item: Requests;
  $refs: {
    ecpSingerRef: ECPSigner;
  };

  get user() {
    return AuthModule.user as IUser;
  }

  async sign() {
    await RequestsModule.getContractorRequest(this.item.record_id);
    await RequestsModule.getAttachments(this.item.record_id);

    const finalXML = {
      title: `Заявление. Прошу заключить договор электроснабжения с "${this.item}" по адресу: "${this.item}" Оплату согласно  выставленным счетам гарантирую.`,
      params: { param: RequestsModule.reqDetailList },
      attachments: {
        attachment: RequestsModule.attachmentList.filter((x) => x.attach_id),
      },
    };

    const builderxml = new xml2js.Builder();
    const xml = builderxml.buildObject(finalXML);
    const signResult = await this.$refs.ecpSingerRef.sign(xml); // 2
    if (!signResult) return;
    //const parsedJSON = await xml2js.parseStringPromise(signResult);
    // Проверка на отозванность и прочее
    const { result: v_result, message: v_message } =
      await SignService.validateEDS(
        signResult as string,
        "SIGNATURE",
        this.user.bin,
      );
    if (!v_result) {
      return BaseModule.showMessage({
        message: translate(v_message as ApiMessageObject).name as string,
        color: "error",
      });
    }

    await RequestsModule.sendReqToConsidering({
      CRRID: this.item.record_id,
      data: signResult as string,
    });

    BaseModule.showMessage({
      message: "requests.req_signed",
      color: "success",
    });
    this.loadTable();
  }

  get listPagination() {
    return RequestsModule.listPagination;
  }

  async loadTable() {
    if (this.user && this.user.record_id) {
      RequestsModule.setloading();
      const req: RequestsDTO = new RequestsDTO();
      req.CRID = this.user.record_id;
      req.iLimit = this.listPagination.itemsPerPage;
      req.iOffset =
        this.listPagination.itemsPerPage * (this.listPagination.page - 1);
      RequestsModule.loadRequestsList(req);
    }
  }

  extractSignature(
    parsedJSON: { [key: string]: any },
    documentRootName: string = "actDocument",
  ): string {
    // определяем количество подписей
    const signaturesLength = parsedJSON.actDocument["ds:Signature"].length;
    return parsedJSON[documentRootName]["ds:Signature"][signaturesLength - 1][
      "ds:SignatureValue"
    ][0];
  }
}
